import clsx from 'clsx';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import styles from './RouteChangeProgress.module.scss';
type Props = {
  className?: string;
};
export const RouteChangeProgress = ({
  className
}: Props) => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const timer = useRef<NodeJS.Timeout | null>(null);
  const [isRouteChanging, setIsRouteChanging] = useState(false);
  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);
    setIsRouteChanging(true);
    timer.current = setTimeout(() => setIsRouteChanging(false), 600);
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, [searchParams, pathname]);
  return <div className={clsx(styles.wrapper, className, isRouteChanging && styles.changing)} data-sentry-component="RouteChangeProgress" data-sentry-source-file="RouteChangeProgress.tsx" />;
};